import {
  DISTRICT_LIBRARY,
  ASSESSMENTS,
  STUDENT_PORTFOLIOS,
  GRADEBOOK,
  GOOGLE_CLASSROOM_GRADE_PASSBACK,
} from './access.constants'

export const ORGANIZATION = [
  DISTRICT_LIBRARY,
  ASSESSMENTS,
  STUDENT_PORTFOLIOS,
  GRADEBOOK,
  GOOGLE_CLASSROOM_GRADE_PASSBACK,
]

export const TEAM_SEAT = [STUDENT_PORTFOLIOS, GRADEBOOK, GOOGLE_CLASSROOM_GRADE_PASSBACK]

export const FREE_TIER = [GRADEBOOK]
